import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import Searchbar from "pages/utils/search_bar";
import { SelectField } from "pages/InputFields/InputFields";
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

const FilterBar = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleRightDrawer = () => setDrawerOpen((prev) => !prev);

    return (
        <>
            <Row className="mb-4 align-items-center">
                <Col md="3" sm="6">
                    <Searchbar />
                </Col>
                <Col xs="auto">
                    <button
                        className="btn btn-white d-flex align-items-center"
                        onClick={toggleRightDrawer}
                        style={{
                            height: "38px", borderRadius: "8px", border: "1px solid #ced4da",
                            backgroundColor: "#fff", padding: "0 15px", boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                        }}
                    >
                        <i className="bx bx-filter-alt me-2 text-muted"></i>
                        <span className="text-muted fw-medium">Filter</span>
                    </button>
                </Col>
            </Row>

            <Drawer open={drawerOpen} onClose={toggleRightDrawer} direction='right' size={450} >
                <div className="d-flex flex-column vh-100">
                    <div className="p-3 d-flex justify-content-between align-items-center border-bottom bg-white">
                        <h4 className="fw-bolder mb-0"> Filter </h4>
                        <button onClick={() => setDrawerOpen(false)}
                            className="btn p-0 d-flex align-items-center justify-content-center"
                            style={{
                                backgroundColor: "#ff0d00", width: "20px", height: "20px",
                                borderRadius: "50%", border: "none", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                            }}
                        >
                            <i className="bx bx-x text-white" style={{ fontSize: "18px" }}></i>
                        </button>
                    </div>
                    <div className="p-4 flex-grow-1">
                        <div className="mb-4">
                            <SelectField label="Position" name="position" isClearable={true} placeholder="Select Position"
                                // value={formData.position} onChange={(option) => setFormData(prev => ({ ...prev, position: option || null }))}
                                options={[
                                    { value: "Top Banner", label: "Top Banner" },
                                    { value: "Sidebar", label: "Sidebar" },
                                    { value: "Popup", label: "Popup" },
                                ]}
                            />
                        </div>

                        <div className="mb-4">
                            <label className="form-label">Start Date</label>
                            <Flatpickr name="created_date" className="form-control d-block"
                                options={{ altInput: true, altFormat: "F j, Y", dateFormat: "Y-m-d", mode: "range" }} placeholder="MM, DD, YYYY"
                            />
                        </div>

                        <div className="mb-4">
                            <label className="form-label">End Date</label>
                            <Flatpickr name="end_date" className="form-control d-block"
                                options={{ altInput: true, altFormat: "F j, Y", dateFormat: "Y-m-d", mode: "range" }} placeholder="MM, DD, YYYY"
                            />
                        </div>

                        <div className="mb-4">
                            <SelectField label="Status" name="status" isClearable={true} placeholder="Select Status"
                                // value={formData.status} onChange={(option) => setFormData(prev => ({ ...prev, status: option || null }))}
                                options={[
                                    { value: "Active", label: "Active" },
                                    { value: "Inactive", label: "Inactive" },
                                ]}
                            />
                        </div>
                    </div>
                    <div className="p-3 border-top d-flex gap-2">
                        <button className="btn btn-danger flex-grow-1" onClick={() => setDrawerOpen(false)}>Reset</button>
                        <button className="btn btn-primary flex-grow-1" onClick={() => setDrawerOpen(false)}>Submit</button>
                    </div>
                </div>
            </Drawer>
        </>
    );
};

export default FilterBar;